export const HOME_USP_CARDS = [
  { textLines: ['£50 free cover', 'as standard'] },
  { textLines: ['16,000+ UK drop-off', 'points'] },
  { textLines: ['Uniformed', 'drivers'] },
  { textLines: ['Lowest price', 'guarantee'] },
  { textLines: ['Send heavy', 'up to 30kg'] },
  { textLines: ['Free', 'real-time', 'tracking'] },
  { textLines: ['Fast worldwide', 'service'] },
  { textLines: ['1 hour', 'delivery window'] },
];

export const HOME_TRUST_BADGE_MSE = {
  brand: 'MoneySavingExpert',
  bodyLine1: "Crowned 'UK's top courier'",
  bodyLine2: '9 times',
};

export const HOME_LANDING_SECTIONS = [
  {
    title: 'Send parcels from anywhere to everywhere.',
    intro:
      "Sending a parcel should feel easy, not stressful. DPD's award-winning network is built around keeping you informed and your parcel protected, from the moment it's collected or dropped off to the moment it's delivered, so you can send with confidence, every time.",
    bullets: [
      '£50 cover included as standard',
      'Book direct from DPD, lowest price guarantee',
      'Live tracking from collection or drop-off to delivery',
    ],
    footer:
      "Simple to book, easy to follow, and built to reduce 'where is it?' messages with proactive updates and delivery options that flex around you and your recipient's life.",
    imageOnLeft: true,
    showTrustBadgesOnImage: true,
  },
  {
    title: 'Worldwide delivery, made simple from £6.40.',
    intro:
      "Sending parcels internationally doesn't have to mean hassle and crossed fingers. DPD's worldwide network means your parcel is in expert hands from the moment you book, with your recipient kept in the loop every step of the way.",
    bullets: [
      'Priority and express options to most overseas destinations',
      '230,000+ worldwide collection points',
      'Straightforward customs support, with live tracking included',
    ],
    footer:
      'Send parcels worldwide with confidence. Your recipient gets real-time updates in their local language, flexible delivery or pick-up options, and a smoother delivery experience from start to finish.',
    imageOnLeft: false,
  },
  {
    title: 'At your convenience.',
    intro:
      "Drop off your way, on your time. With over 16,000 DPD Pickup and drop-off points across the UK, including Post Offices, Sainsbury's, Argos, and 24/7 lockers, there's always somewhere close by that works around your day, not the other way around.",
    bullets: [
      'No printer? No problem. Get free label printing at drop-off',
      '16,000+ hand-picked and loved locations nationwide',
      '24/7 lockers available for maximum flexibility',
    ],
    footer:
      "Simply choose a nearby drop-off point or locker, scan your label, and we'll take it from there, while keeping you updated along your parcel's journey.",
    imageOnLeft: true,
  },
  {
    title: "You're in control.",
    intro:
      "With most parcel delivery and courier companies you only find out where your parcel is at a few fixed points in the journey, sometimes with gaps of up to 12 hours. DPD gives you live updates so you and your recipient always know exactly what's happening.",
    bullets: [
      'Real-time notifications, including a 15-minute heads-up',
      '1 hour delivery window, so no waiting around',
      'In-flight options: reroute, safe place, leave with a neighbour, and much more',
    ],
    footer:
      'DPD is designed around real life, for real people. Your recipient can easily adapt the delivery themselves without the usual hassle.',
    imageOnLeft: false,
  },
  {
    title: "It's about time.",
    intro:
      "Not every parcel is the same, and your delivery options shouldn't be either. Whether you're sending something that can wait or something that can't, DPD has a service that works for you.",
    bullets: [
      'Economy delivery from £2.99 when value matters',
      'Next day, with even faster upgrade options like before 10:30am',
      'Same Day for urgent sends, powered by CitySprint',
    ],
    footer:
      'Fast, flexible, and reliable. Whether you want to track every step or leave it with us, you can trust us to make sure it gets there at the time you choose.',
    imageOnLeft: true,
  },
  {
    title: 'Sending with DPD means sending smarter.',
    intro:
      'Whether you send it once a month, a week, or every single day, DPD gives you the power to do it faster, cheaper, and without the hassle of going through a middleman.',
    bullets: [
      'Send multiple parcels in one go',
      'Smart tools that make repeat sending quicker',
      'Lowest price guarantee from only £2.99 inc. VAT',
    ],
    footer:
      "Whether you're shipping a gift, selling on eBay, Etsy, or Facebook Marketplace, or running a small business, you get a smoother checkout and a premium delivery experience every time – because you deserve better than basic.",
    imageOnLeft: false,
  },
  {
    title: "Everything you need. Nothing you don't.",
    intro:
      "DPD is an award-winning delivery company built around one idea: that sending a parcel should be as easy for you as receiving one is for your recipient. Here's why sending with DPD makes sense:",
    bullets: [
      'Rated Excellent on Trustpilot by over 2 million UK customers',
      '£50 cover included as standard',
      '1 hour delivery window with a 15-minute heads-up, every time',
      'No account necessary; get a quote in seconds and send in minutes',
      '16,000+ drop-off points, 24/7 lockers, and free label printing',
      'Lowest price guarantee when you book with DPD Online',
    ],
    footer:
      "No contracts. No hidden fees. No hassle. Just great delivery. It's as good as taking it there yourself.",
    imageOnLeft: true,
  },
];
